import classnames from "classnames";

export const RoundedBox = ({ className, title, description, children }) => {
    const cn = classnames;
    return (
        <div className={cn('rounded-lg shadow-md p-5', className)}>
            {title && <h3 className="text-lg font-bold">{title}</h3>}
            {description && <p className="mt-2 text-xs text-gray-700 mb-4">{description}</p>}
            {children}
        </div>
    );
};
